const not = (value) => !value;

export default not;
